// extracted by mini-css-extract-plugin
export default {"page":"loginPage_page__q0ok7","form":"loginPage_form__iMAM-","forgotButtons":"loginPage_forgotButtons__MBdyU"};